export default {"src":"/_next/static/media/close.7f8608d0.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};